import { remoteUrl, urlWithParams } from "../../helpers/UrlHelpers";

const WATCHER_URL   = process.env.REACT_APP_WATCHER_URL;
const PUBLIC_ROUTES = [`${WATCHER_URL}/login`];

const isPublicUrl = (baseURL?: string, url?: string): boolean => {
  return PUBLIC_ROUTES.includes(`${baseURL}/${url}`);
}

function bundlePath(this: any, id: number) {
  return `/bundles/${id}`;
}
function bundlesPath(this: any, params?: object) {
  return urlWithParams('/bundles', params);
}

const watcherUrls = {
  baseURL: WATCHER_URL,
  PUBLIC_ROUTES: PUBLIC_ROUTES,
  isPublicUrl: isPublicUrl,

  remoteUrl: remoteUrl,

  bundlePath:         bundlePath,
  bundlesPath:        bundlesPath,
}

export default watcherUrls;
